<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item :link="{
          name: $t('dashboard'),
          path: '/dashboard',
          icon: 'fas fa-chart-line text-blue',
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('ingresos'),
          path: '/ingresos',
          icon: 'ni ni-delivery-fast text-blue'
        }">
          <sidebar-item :link="{
            name: $t('todos'),
            path: '/ingresos',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('incompletos'),
            path: '/ingresos/incompletos/1',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('pendientes'),
            path: '/ingresos/pendientes/2',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('completos'),
            path: '/ingresos/completados/3',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('pagados'),
            path: '/ingresos/pagados/4',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('egresos'),
          path: '/egresos',
          icon: 'ni ni-delivery-fast text-blue icon-mirror'
        }">
          <sidebar-item :link="{
            name: $t('todos'),
            path: '/egresos',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('incompletos'),
            path: '/egresos/incompletos/1',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('pendientes'),
            path: '/egresos/pendientes/2',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('completos'),
            path: '/egresos/completados/3',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('pagados'),
            path: '/egresos/pagados/4',
            icon: 'ni ni-money-coins text-blue'
          }">
          </sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('estado_pagos'),
          path: '/pagos',
          icon: 'ni ni-single-copy-04 text-blue'
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('empresas'),
          path: '/empresas',
          icon: 'fa fa-building text-blue'
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('usuarios'),
          path: '/usuarios',
          icon: 'ni ni-single-02 text-blue'
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('choferes'),
          path: '/choferes',
          icon: 'ni ni-bus-front-12 text-blue'
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('materiales'),
          path: '/materiales',
          icon: 'ni ni-settings-gear-65 text-blue'
        }">
        </sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('plantas'),
          path: '/plantas',
          icon: 'fa fa-industry text-blue'
        }"></sidebar-item>
        <sidebar-item v-if="rol == 'admin'" :link="{
          name: $t('folios'),
          path: '/folios',
          icon: 'fa fa-file-alt text-blue'
        }"></sidebar-item>
        <li class="nav-item">
          <a :href="materialesUrl" class="nav-link">
            <i class="fas fa-boxes text-blue"></i>
            <span class="nav-link-text">{{ $t('portal_materiales') }}</span>
          </a>
        </li>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import { FadeTransition } from 'vue2-transitions';
import utilsService from '@/api/utilsService';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  computed: {
    rol() {
      return utilsService.getRol();
    },
    materialesUrl() {
      return process.env.VUE_APP_MATERIALES_URL || 'https://portalmateriales.inexlink.com';
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>

<style scope lang="scss">
.icon-mirror {
  transform: scaleX(-1);
  display: inline-block;
  transform-origin: center;
  margin-right: 10%;    
  margin-left: -10%;
}

.text-blue{
  color: #07306b !important;
}

.btn-primary{
  background: #07306b !important;
  border: none !important;
}
.btn-info{
  background: #2271b5 !important;
  border: none !important;
}

.btn-secondary{
  background: #07306b !important;
  border: none !important;
  color: #fff;
}
.btn-secondary:hover{
  background: #07306b !important;
  border: none !important;
  color: #fff;
}
.btn-warning{
  background: #2271b5 !important;
  border: none !important;
}
</style>
